<template>
	<div class="know-info-cls">
		<section class="title-cls">
			<span><svg-icon :icon-class="(knowInfo.type == '1') ? 'KnowArticle' : 'KnowProcess'" /> {{knowInfo.q}}</span>
			<svg-icon @click.stop="handleClose" icon-class="KnowClose" />
		</section>
		<section class="context-cls">
			<div class="breadcrumb-cls" v-if="sourceType !== 'TouchIn'">
				<span class="label-cls" v-if="knowInfo.nodeNames">当前位置：</span>
				<el-breadcrumb v-if="knowInfo.nodeNames" separator-class="el-icon-arrow-right">
					<el-breadcrumb-item>{{knowInfo.resource.name}}</el-breadcrumb-item>
					<el-breadcrumb-item v-for="(item, index) in knowInfo.nodeNames.split(',')" :key="index">{{item}}</el-breadcrumb-item>
				</el-breadcrumb>
				<span class="appendix" v-if="$$(knowInfo, 'a', 'appendixList', 'length') > 0">
					<el-dropdown @command="handleDownLoadFile" trigger="click" placement="bottom-start">
						<i><svg-icon icon-class="KnowAppendix" /> 附件</i>
						<el-dropdown-menu slot="dropdown">
							<el-dropdown-item v-for="(file, index) in $$(knowInfo, 'a', 'appendixList')" :key="index" :command="file">{{file.name}}</el-dropdown-item>
						</el-dropdown-menu>
					</el-dropdown>
				</span>
				<span @click.stop="drawerKnowledge = true" v-if="sourceType === 'Review'" class="appendix"><el-button size="mini">查看原文</el-button></span>
			</div>
			<div v-if="(knowInfo.type == '1')" class="content-cls" v-html="$$(knowInfo, 'a', 'welfareText')"></div>
			<div v-else class="content-cls">
				<div class="cell" :class="{'active': activeId === item.id}" v-for="(item, index) in themeList" :key="index">
					<i @click.stop="handleSwitch(item, index)">{{index + 1}}</i>
					<div class="title">
						<span class="text">{{item.name}}</span>
						<span class="appendix" v-if="$$(item, 'appendixList', 'length') > 0">
							<el-dropdown @command="handleDownLoadFile" trigger="click" placement="bottom-start">
								<i><svg-icon icon-class="KnowAppendix" /> 附件</i>
								<el-dropdown-menu slot="dropdown">
									<el-dropdown-item v-for="(file, index) in $$(item, 'appendixList')" :key="index" :command="file">{{file.name}}</el-dropdown-item>
								</el-dropdown-menu>
							</el-dropdown>
						</span>
					</div>
					<div class="speak" v-if="item.isSpeak && item.speak">
						<svg-icon icon-class="Knowxz" style="margin-right: 5px; color: #337EFF;font-size: 18px" />
						<span style="color: #337EFF">推荐话术：</span>
						<span>{{item.speak}}</span>
					</div>
					<div v-html="item.welfareText"></div>
					<div class="welfare" v-if="item.isJumpOption">
						<svg-icon icon-class="Knowkr" style="margin-right: 5px; color: #47b267; font-size: 16px" />
						<span style="color: #47b267">回答：</span>
						<el-radio-group v-model="item.value" @change="(ev) => { return handleNext(ev, index, item)}" :disabled="activeId !== item.id">
							<el-radio v-for="(_item, _index) in item.jumpOption" :key="_index" :label="_item.id">{{_item.name}}</el-radio>
						</el-radio-group>
					</div>
					<div class="btns" v-if="!item.isJumpOption && count !== $$(knowInfo, 'a', 'themeList', 'length') && item.nextId">
						<el-button type="primary" size="mini" @click.stop="handleNext(item.nextId, index, item)" :disabled="activeId !== item.id">下一步</el-button>
					</div>
				</div>
				<div class="end-cls" v-if="isEnd">
					<span class="svg-icon"><svg-icon icon-class="KnowEnd" /> </span>
					<span class="end">
						流程结束
					</span>
				</div>
			</div>
			<div class="review-cls" v-if="sourceType === 'Review'">
				<div class="title">修改原因</div>
				<div>{{knowInfo.createRemark}}</div>
				<div class="time">{{knowInfo.createUserName}}：{{knowInfo.createTime | formatDate}} 修改</div>
				<div class="btn" v-show="knowInfo.status == 9">
					<el-button @click.stop="handleReview(knowInfo, 1)" :loading="loading" size="mini" type="primary">通过</el-button>
					<el-button @click.stop="handleReview(knowInfo, 0)" :loading="loading" size="mini">不通过</el-button>
				</div>
			</div>
		</section>
		<el-drawer
			size="60%"
			:modal="false"
			:modal-append-to-body="false"
			:withHeader="false"
			:visible.sync="drawerKnowledge">
			<KnowInfoG v-if="drawerKnowledge" sourceType="Report" :qaId="item.qaId" @drawerKnowInfoClose="drawerKnowledge = false;" />
		</el-drawer>
	</div>
</template>

<script>
import { mapGetters } from 'vuex';
export default {
	name: 'KnowledgeInfo',
	props: ['sourceType', 'touchInForm', 'qaId', 'item'],
	computed: {
		...mapGetters([
			'userInfo',
		]),
	},
	data() {
		return {
			loading: false,
			drawerKnowledge: false,
			knowInfo: {},
			activeId: '',
			count: 1,
			currentIndex: '',
			isClear: false,
			themeList: [],
			isEnd: false
		}
	},
	created() {
		if(this.sourceType === 'TouchIn') {
			this.knowInfo = this.touchInForm;
			if(this.knowInfo.type == '2') {
				this.themeList = [this.knowInfo?.a?.themeList[0]];
				this.activeId = this.knowInfo?.a?.themeList[0]['id'];
				if(this.themeList[0].nextId || this.themeList[0].isJumpOption) {
					this.isEnd = false;
				} else {
					this.isEnd = true;
				}
			}
			return;
		}
		this.getQaDetail();
	},
	methods: {
		handleReview(row, status) {
			this.$prompt(`${status == 1 ? '审批通过后，被修改的知识将直接更新生效，请确认。' : ''}`, `${status == 1 ? '确认：是否通过审批' : '审批不通过'}`, {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				showInput: status == 1 ? false : true,
				inputPattern: status == 1 ? null : /\S/,
				InputType: 'textarea',
				inputPlaceholder: '在此备注不通过原因，方便坐席查看',
				inputErrorMessage: '请输入不通过原因',
			}).then(({ value }) => {
				this.loading = true;
				this.$api.apiPostKnowledgeQATaskApproveQAUpd({
					id: row.id,
					status: status,
					auditRemark: value,
					projectId: row.projectId
				}).then(response => {
					if(response.errcode != 0) {
						this.loading = false;
						return;
					}
					this.$message({
						type: 'success',
						message: '审批完成'
					});
					this.$emit('drawerKnowInfoClose');
				});
			});
		},
		handleSwitch(item, index) {
			if(item.id === this.activeId) return;
			this.currentIndex = index;
			this.activeId = item.id;
			this.isClear = true;
		},
		handleNext(e, index, cell) {
			let id = e;
			if(cell.isJumpOption) {
				for(const item of cell.jumpOption) {
					if(e === item.id) {
						id = item.nextId;
					}
				}
			} else {
				id = cell.nextId;
			}
			if(this.isClear){
				this.isClear = false;
				this.themeList = this.themeList.splice(0, this.currentIndex + 1);
				this.count = this.currentIndex + 1;
				setTimeout(() => {
					this.currentIndex = index;
					this.activeId = id;
					this.count = this.count += 1;
					for(const item of this.knowInfo?.a?.themeList) {
						if(id === item.id) {
							this.$set(item, "value", '');
							this.$set(item, "isSummary", true);
							this.themeList.push(item);
							if(item.nextId || item.isJumpOption) {
								this.isEnd = false;
							} else {
								this.activeId = '';
								this.isEnd = true;
							}
						}
					}
				}, 100);
			} else {
				setTimeout(() => {
					this.currentIndex = index;
					this.activeId = id;
					this.count = this.count += 1;
					for(const item of this.knowInfo?.a?.themeList) {
						if(id === item.id) {
							this.$set(item, "isSummary", true);
							this.themeList.push(item);
							if(item.nextId || item.isJumpOption) {
								this.isEnd = false;
							} else {
								this.activeId = '';
								this.isEnd = true;
							}
						}
					}
				}, 100);
			}
		},
		getQaDetail() {
			if(this.sourceType === 'Review') {
				this.$api.apiPostKnowledgeQATaskGetEntityById({projectId: this.userInfo.brandIdentify, id: this.qaId}).then(response => {
					if(response.errcode != 0) return;
					this.knowInfo = response.data;
					this.knowInfo.a = JSON.parse(this.knowInfo.a);
					if(this.knowInfo.type == '2') {
						this.themeList = [this.knowInfo?.a?.themeList[0]];
						this.$set(this.themeList[0], "isSummary", true);
						this.activeId = this.knowInfo?.a?.themeList[0]['id'];
						if(this.themeList[0].nextId || this.themeList[0].isJumpOption) {
							this.isEnd = false;
						} else {
							this.isEnd = true;
						}
					}
				});
			} else {
				this.$api.apiPostKnowledgeQAInfo({projectId: this.userInfo.brandIdentify, id: this.qaId}).then(response => {
					if(response.errcode != 0) return;
					this.knowInfo = response.data;
					this.knowInfo.a = JSON.parse(this.knowInfo.a);
					if(this.knowInfo.type == '2') {
						this.themeList = [this.knowInfo?.a?.themeList[0]];
						this.$set(this.themeList[0], "isSummary", true);
						this.activeId = this.knowInfo?.a?.themeList[0]['id'];
						if(this.themeList[0].nextId || this.themeList[0].isJumpOption) {
							this.isEnd = false;
						} else {
							this.isEnd = true;
						}
					}
				});
			}
		},
		handleDownLoadFile(command) {
			let $a = document.createElement('a');
			$a.setAttribute("href", command.url);
			$a.setAttribute("download", command.name);
			$a.setAttribute("target", "_parent");
			let evObj = document.createEvent('MouseEvents');
			evObj.initMouseEvent( 'click', true, true, window, 0, 0, 0, 0, 0, false, false, false, false, 0, null);
			$a.dispatchEvent(evObj);
		},
		handleClose() {
			this.$emit('drawerKnowInfoClose');
		}
	}
}
</script>

<style lang="scss" scoped>
::v-deep img {
	width: 100%;
}
.know-info-cls {
	width: 100%;
	height: 100%;
	overflow: hidden;
	position: relative;

	& > .title-cls {
		height: 50px;
		padding: 10px 20px;
		box-sizing: border-box;
		line-height: 30px;
		border-bottom: 1px solid #D8D8D8;

		& > span {
			font-size: 20px;
			color: #72767b;
			font-weight: 900;
			margin-right: 16px;
			letter-spacing: 1px;
			
		}

		& > .svg-icon {
			float: right;
			margin-top: 8px;
			cursor: pointer;
		}
	}

	& > .context-cls {
		width: 100%;
		height: calc(100% - 60px);
		padding: 10px 20px 50px;
		box-sizing: border-box;
		overflow-x: hidden;
		overflow-y: auto;

		& > .breadcrumb-cls {
			width: 100%;
			min-height: 30px;
			margin-top: 10px;

			& > .label-cls {
				font-size: 14px;
				color: #606266;
				position: relative;
				top: -2px;
				vertical-align: top;
			}

			& .el-breadcrumb {
				display: inline-block;
				width: calc(100% - 200px);
				overflow: hidden;
				// white-space: nowrap;
				text-overflow: ellipsis;

				& > .el-breadcrumb__item {
					margin-bottom: 10px;
				}
			}

			& > .appendix {
				float: right;
				width: 100px;
				text-align: right;
				cursor: pointer;
				& i {
					font-style: normal;
					color: #337EFF;
				}
			}
		}

		& > .content-cls {
			padding-left: 20px;
			width: 100%;
			box-sizing: border-box;
			margin-bottom: 20px;

			& > .cell {
				width: 100%;
				padding-left: 34px;
				box-sizing: border-box;
				position: relative;
				margin-bottom: 10px;

				&::before {
					content: "";
					width: 1px;
					height: 100%;
					background: #c8c9cc;
					position: absolute;
					top: 24px;
					left: 12px;
				}

				&:last-child::before {
					display: none;
				}

				& > i {
					display: inline-block;
					text-align: center;
					font-style: normal;
					width: 24px;
					height: 24px;
					background: #c8c9cc;
					color: #fff;
					font-size: 14px;
					line-height: 24px;
					border-radius: 50%;
					position: absolute;
					top: 0;
					left: 0;
					cursor: pointer;
				}

				&.active {

					& > i {
						background: #337EFF;
					}
				}

				& > .title {
					font-size: 14px;
					font-weight: bold;
					color: #3C4353 ;
					line-height: 24px;
					margin-bottom: 16px;

					& > .text {
						display: inline-block;
						width: calc(100% - 170px);
					}

					& > .appendix {
						display: inline-block;
						width: 100px;
						text-align: right;
						cursor: pointer;
						& i {
							font-style: normal;
							color: #337EFF;
						}
					}

					& > .summary {
						margin-left: 15px;
						float: right;
					}
				}

				& > .speak {
					font-size: 16px;
					font-weight: 400;
					color: #6C7E91;
					line-height: 24px;
					margin-bottom: 16px;
				}

				& > .welfare {
					margin-bottom: 16px;
					margin-top: 16px;
					& > span {
						font-size: 16px;
						font-weight: 400;
						color: #6C7E91;
						line-height: 24px;
					}
				}

				& .btns {
					margin-top: 13px;
				}
			}

			& .end-cls {
				margin: 20px 0;
				font-size: 16px;
				color: #c0c4cc;
				font-weight: bold;
				padding-left: 35px;
				box-sizing: border-box;
				position: relative;

				& > .svg-icon {
					background: #D7D7D7;
					display: block;
					width: 24px;
					height: 24px;
					border-radius: 50%;
					position: absolute;
					left: 0px;
					font-size: 10px;
					line-height: 22px;
					text-align: center;

					& > .svg-icon {
						color: #fff;
					}
				}

				& > .end {
					display: inline-block;
					height: 20px;
					line-height: 23px;
					vertical-align: top;
					color: #D7D7D7;
					font-size: 14px;
					font-weight: bold;
					margin-right: 21px;
				}

				& > .el-button {
					font-size: 14px;
					padding: 0;
					color: #337EFF;
					line-height: 24px;

					& > .svg-icon {
						color: #337EFF;
					}
				}
			}
		}

		& > .review-cls {
			width: 100%;
			border-top: dashed 1px #D8D8D8;
			padding-top: 20px;
			box-sizing: border-box;
			color: #68798d;
			font-size: 14px;
			font-weight: 400;
			line-height: 26px;

			& > .title {
				font-size: 14px;
				font-weight: 400;
				color: #606266;
			}

			& > .time {
				color: #9b9b9b;
			}

			& > .btn {
				width: 100%;
				border-top: solid 1px #D8D8D8;
				margin-top: 40px;
				line-height: 50px;
				text-align: right;
			}
		}
	}
}
</style>